export default "__VITE_ASSET__GcbVW9n7__"